export default __webpack_public_path__ + "static/media/me-720px.de2d8c50.png";